import { useSelector } from 'react-redux';
import type { ReactNode } from 'react';

import { selectIsAuthenticated } from '../redux/selectors';
import { useWebSocket } from '../hooks/useWebSocket';
import { handleWebSocketEvent } from '../events/webSocketHandlers';
import { AppShell } from '../components/AppShell';

type MainLayoutV2Props = { children: ReactNode };

const MainLayoutV2 = ({ children }: MainLayoutV2Props) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useWebSocket({
    enabled: isAuthenticated,
    onEvent: handleWebSocketEvent,
  });

  return <AppShell>{children}</AppShell>;
};

export default MainLayoutV2;
